import React, { useState } from "react";

import TextareaList from "../../form-inputs/textarea-list";

const TextareaListExamples = () => {
    const [values, setValues] = useState(["Item 1", "Item 2"]);

    const updateField = (name, value) => {
        setValues(value);
    };

    return <TextareaList defaultValue={values} updateOnChange={updateField} />;
};

export default TextareaListExamples;
